import { render, staticRenderFns } from "./ImportLoadingModal.vue?vue&type=template&id=24624c85&scoped=true"
import script from "./ImportLoadingModal.vue?vue&type=script&lang=ts"
export * from "./ImportLoadingModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24624c85",
  null
  
)

export default component.exports